import React, { useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { InformationBox, useToast } from '@app/core';
import { Trans, useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { LoginParticipantContent } from '@app/auth';
import { useShortUrl } from '@app/api';
import QueryString from 'qs';

const useStyles = createUseStyles((theme: Theme) => ({
  message: {
    ...theme.fonts.caption,
  },
  container: {
    width: theme.maxContentWidth.largeForm,
    margin: '0 auto',
    padding: theme.marginBase * 2,
    marginTop: theme.marginBase * 4,
    maxWidth: '100%',
  },
}));

const allowedVerbs = [
  'finish',
  'complete',
  'quality',
  'notSerious',
  'lied',
  'technical',
  'quotafull',
  'screenout',
  'legal',
  'duplicate',
];

export const RequireLogin = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const shortUrl = useShortUrl();
  const queryParams = QueryString.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const message = String(queryParams.message) || '';

  const { verb, code } = useParams();
  const redirect = useCallback(() => {
    // @ts-ignore
    window.location = `${shortUrl}/study/${verb}/${code}`;
  }, [shortUrl, verb, code, navigate]);

  useEffect(() => {
    if (verb && !allowedVerbs.includes(verb)) {
      navigate('/');
    }
  }, [verb, navigate]);

  const text = useMemo(() => {
    if (message === 'NoMatchingParticipation') {
      return 'requireLogin.NoMatchingParticipation';
    }
    if (verb === 'start') {
      return 'requireLogin.startingInfo';
    }
    return 'requireLogin.finishInfo';
  }, [message]);

  return (
    <div className={classes.container}>
      <LoginParticipantContent
        title={t('auth.login.title')}
        onSuccess={redirect}
      >
        <InformationBox>
          <div className={classes.message}>
            <Trans i18nKey={text} />
          </div>
        </InformationBox>
      </LoginParticipantContent>
    </div>
  );
};
